<template>
  <div class="market" :class="layout">
    <div class="market-header">
      <div class="name">
        {{ market.name }}
      </div>
    </div>
    <div
      v-if="market.tileIds.length"
      class="market-content"
    >
      <tile
        v-for="(tile, tileIndex) in tiles"
        :key="tileIndex"
        :index="(index * tileCount) + tileIndex"
        :tile="tile"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { randomInterval } from '@/utils/random';
import Tile from './_Tile';

export default {
  name: 'Market',
  components: {
    Tile,
  },
  props: {
    market: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    layout: {
      type: String,
      default: '',
    },
    tileCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters('playback', { frozenBroadcastId: 'activeBroadcastId' }),
    ...mapGetters('markets', ['marketTiles']),

    tiles() {
      return this.marketTiles(this.market.id);
    },
  },
  created() {
    this.loadBroadcasts(this.market.id)
      .then(() => this.createTiles({
        marketId: this.market.id,
        tileCount: this.tileCount,
      }))
      .then(() => {
        this.$options.interval = setInterval(() => {
          this.updateRandomTile({
            marketId: this.market.id,
            frozenBroadcastId: this.frozenBroadcastId,
          });
        }, randomInterval());
      });
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  },
  methods: {
    ...mapActions('markets', ['loadBroadcasts', 'createTiles', 'updateRandomTile']),
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables";
@import "~@/assets/scss/layout";

.market {
  @extend %market;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  font-size: 3vh;
  padding: 2vh;

  .market-header {
    overflow: hidden; // new block formatting context
    padding: 0 1% 2% 1%;

    .name {
      float: left;
      font-weight: $weight-bold;
      text-transform: uppercase;
      letter-spacing: 1px;
      line-height: 1.2;
      width: 65%;
    }
    .time {
      float: right;
      width: 35%;
      text-align: right;
      font-weight: $weight-light;
    }
    .name, .time {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      display: inline-block;
    }
  }

  .market-content {
    height: 100%;
  }

  &.landscape-4k {
    font-size: 2.7vh;
    padding: 1.3vw 1.75vw 2.05vw;
  }

  &.landscape-4k-4m {
    font-size: 2.7vh;
    padding: 2vw;
  }
}
</style>
